import * as yup from "yup";
import { getPhoneValidation } from "constants/validate";
export const validateSchemaBasicForm = t => {
  const rules = {
    hub_name: yup
      .string()
      .required(t("message.required", { title: t("form.hub_name") })),

    hub_order_code: yup
      .string()
      .required(t("message.required", { title: t("form.hub_order_code") })),

    hub_transport_code: yup.string().when("is_center", {
      is: true,
      then: schema =>
        schema.required(
          t("message.required", { title: t("form.hub_transport_code") })
        ),
      otherwise: schema => schema.notRequired().nullable(),
    }),

    address: yup
      .string()
      .required(t("message.required", { title: t("form.address") })),

    province_code: yup
      .object()
      .required(t("message.required", { title: t("form.province_code") }))
      .nullable(),
    district_code: yup
      .object()
      .required(t("message.required", { title: t("form.district_code") }))
      .nullable(),
    ward_code: yup
      .object()
      .required(t("message.required", { title: t(" Phường / Xã") }))
      .nullable(),

    province_code_new: yup.object().nullable(),
    district_code_new: yup.object().nullable(),

    parent_hub_id: yup.object().when("is_center", {
      is: false,
      then: schema =>
        schema
          .required(t("message.required", { title: t("form.parent_hub_id") }))
          .nullable(),
      otherwise: schema => schema.notRequired().nullable(),
    }),

    allowed_time: yup
      .string()
      .transform(function (value, originalValue) {
        return originalValue === null || originalValue === ""
          ? undefined
          : value;
      })
      .when("forwarding_current_shift", {
        is: true,
        then: schema =>
          schema.required(
            t("message.required", { title: t("form.minimum_remaining_time") })
          ),
        otherwise: schema => schema.notRequired(),
      }),
  };

  return yup.object().shape(rules);
};
const phoneRegex = /^(?:\d\s?){10,14}$/;
export const validateSchema = (t, activeAddressType) => {
  const rules = {
    hub_name: yup
      .string()
      .required(t("message.required", { title: t("form.hub_name") })),
    hub_order_code: yup
      .string()
      .required(t("message.required", { title: t("form.hub_order_code") })),
    hub_transport_code: yup.string().when("is_center", {
      is: true,
      then: yup
        .string()
        .required(
          t("message.required", { title: t("form.hub_transport_code") })
        ),
      otherwise: yup.string().nullable(),
    }),
    address: yup
      .string()
      .required(t("message.required", { title: t("form.address") })),

    district_code: yup
      .object()
      .required(t("message.required", { title: t("form.district_code") }))
      .nullable(),
    ward_code: yup
      .object()
      .required(t("message.required", { title: t("form.ward_code") }))
      .nullable(),
    province_code: yup
      .object()
      .required(t("message.required", { title: t("form.province_code") }))
      .nullable(),

    province_code_new: yup.object().nullable(),
    district_code_new: yup.object().nullable(),

    parent_hub_id: yup.object().when("is_center", {
      is: false,
      then: yup
        .object()
        .required(t("message.required", { title: t("form.parent_hub_id") }))
        .nullable(),
      otherwise: yup.object().nullable(),
    }),

    allowed_time: yup
      .string()
      .transform(function (value, originalValue) {
        return originalValue === null ? undefined : value;
      })
      .when("forwarding_current_shift", {
        is: true,
        then: yup
          .string()
          .required(
            t("message.required", { title: t("form.minimum_remaining_time") })
          ),
        otherwise: yup.string(),
      }),
    contact_person_name_add: yup
      .string()
      .required(
        t("message.required", { title: t("form.contact_person_name") })
      ),
    contact_person_phone_1_add: yup
      .string()
      .nullable()
      .required(
        t("message.required", {
          title: t("form.contact_person_phone_1"),
        })
      )
      .matches(getPhoneValidation(t).regex, getPhoneValidation(t).errorMessage)
      .when(getPhoneValidation(t).when),
    contact_person_phone_2_add: yup
      .string()
      .nullable()
      .matches(getPhoneValidation(t).regex, getPhoneValidation(t).errorMessage)
      .when(getPhoneValidation(t).when),
    ship_partner_receive_sample: yup
      .object()
      .required(t("message.required", { title: t("form.ship_partner") }))
      .nullable(),

    ship_unit_receive_sample: yup
      .object()
      .required(t("message.required", { title: t("form.ship_unit") }))
      .nullable(),
    ship_partner_return_result: yup
      .object()
      .required(t("message.required", { title: t("form.ship_partner") }))
      .nullable(),

    ship_unit_return_result: yup
      .object()
      .required(t("message.required", { title: t("form.ship_unit") }))
      .nullable(),

    user_account: yup
      .object()
      .required(t("message.required", { title: t("form.user_account") }))
      .nullable(),
  };
  if (activeAddressType === "three_level") {
    rules.ward_code = yup
      .object()
      .nullable()
      .required(t("form.validate.required", { title: "Phường xã" }));
  }

  const schema = yup.object().shape(rules);
  return schema;
};

export const validateSchemaAddHubContac = t => {
  const rules = {
    contact_person_name_add: yup.string().required(t("message.required")),
    contact_person_phone_1_add: yup
      .string()
      .required(t("message.required"))
      .matches(/^\d*$/, "Số điện thoại không hợp lệ") // Allow empty string or digits only
      .when((phone_number, yupNext) => {
        if (phone_number && phone_number.substring(0, 1) == 0) {
          return yupNext.length(
            10,
            t("common:validate.char_length", { length: 10 })
          );
        } else if (phone_number) {
          return yupNext
            .min(7, t("common:validate.char_min", { min: 7 }))
            .max(11, t("common:validate.char_max", { max: 11 }));
        }
        return yupNext; // No additional validation for empty string
      }),
    contact_person_phone_2_add: yup
      .string()
      .nullable()
      .matches(/^\d*$/, "Số điện thoại không hợp lệ") // Allow empty string or digits only
      .when((phone_number, yupNext) => {
        if (phone_number && phone_number.substring(0, 1) == 0) {
          return yupNext.length(
            10,
            t("common:validate.char_length", { length: 10 })
          );
        } else if (phone_number) {
          return yupNext
            .min(7, t("common:validate.char_min", { min: 7 }))
            .max(11, t("common:validate.char_max", { max: 11 }));
        }
        return yupNext; // No additional validation for empty string
      }),
  };

  const schema = yup.object().shape(rules);
  return schema;
};
